import circleFacebookIcon from "../../assets/images/FacebookIcon.svg";

function FacebookCircleIcon() {
  return <img className="w-6 h-6" src={circleFacebookIcon} />;
}

export default FacebookCircleIcon;
